import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API_CONFIG } from '../apiConfig'; 
import styles from '../css/AnnouncementModal.module.css';

const MONTH_NAMES = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

const formatDayAndMonthName = (dateString) => {
    if (!dateString) return '';
    const parts = dateString.split('-');
    if (parts.length < 3) return dateString; 
    const monthIndex = parseInt(parts[1], 10) - 1; 
    const day = parts[2]; 
    return `${day} de ${MONTH_NAMES[monthIndex]}`;
};

const AnnouncementModal = ({ isOpen, onClose }) => {
    const [semanaAvisos, setSemanaAvisos] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const fetchSemanaAvisos = useCallback(async () => {
        setIsLoading(true);
        try {
            const url = API_CONFIG.AVISOS_SEMANA || 'https://avisos-iump-concon.pages.dev/api/avisos';
            const response = await axios.get(url);
            setSemanaAvisos(response.data); 
        } catch (error) {
            console.error("Error al cargar la semana de avisos:", error);
            setSemanaAvisos(null);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            fetchSemanaAvisos();
        } else {
            document.body.style.overflow = 'unset';
        }
    }, [isOpen, fetchSemanaAvisos]);

    if (!isOpen) return null;

    const subtituloRango = semanaAvisos 
        ? `Del ${formatDayAndMonthName(semanaAvisos.fecha_inicio)} al ${formatDayAndMonthName(semanaAvisos.fecha_fin)}`
        : "Cargando fechas...";

    return (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.modalSide} onClick={(e) => e.stopPropagation()}>
                
                <div className={styles.header}>
                    <div className={styles.headerTitle}>
                        <i className="fas fa-bullhorn"></i>
                        <div>
                            <h2 className={styles.mainTitle}>Avisos de la Semana</h2>
                            <span className={styles.subtitle}>{subtituloRango}</span>
                        </div>
                    </div>
                    <button className={styles.closeBtn} onClick={onClose}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                <div className={styles.content}>
                    {isLoading ? (
                        <div className={styles.loader}>
                            <div className={styles.spinner}></div>
                            <p>Cargando bendiciones...</p>
                        </div>
                    ) : (
                        <div className={styles.timeline}>
                            {semanaAvisos?.dias?.map((dia, index) => (
                                <div key={index} className={styles.dayGroup}>
                                    <div className={styles.dayLabel}>
                                        <span>{dia.dia_semana_display} {formatDayAndMonthName(dia.fecha_dia)}</span>
                                    </div>
                                    
                                    {dia.avisos.length > 0 ? (
                                        dia.avisos.map((aviso, i) => (
                                            <div key={i} className={styles.avisoCard}>
                                                <div className={styles.avisoDot}></div>
                                                <div className={styles.avisoInfo}>
                                                    <h4>{aviso.titulo}</h4>
                                                    <p>{aviso.descripcion}</p>
                                                    
                                                    {/* NUEVA SECCIÓN PARA HORA Y LUGAR */}
                                                    <div className={styles.avisoMeta}>
                                                        {aviso.hora && (
                                                            <span className={styles.metaItem}>
                                                                <i className="far fa-clock"></i> 
                                                                {aviso.hora.substring(0, 5)} hrs
                                                            </span>
                                                        )}
                                                        {aviso.lugar && (
                                                            <span className={styles.metaItem}>
                                                                <i className="fas fa-map-marker-alt"></i> {aviso.lugar}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p className={styles.noAvisosDay}>Sin actividades programadas</p>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className={styles.footer}>
                    <p>© IUMP Concón — Equipo Informático</p>
                </div>
            </div>
        </div>
    );
};

export default AnnouncementModal;